import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b1a7826a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "base-company-dialog-title",
  style: {"margin-top":"0px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "base-company-dialog-title" }, "账号登录信息", -1))
const _hoisted_3 = {
  class: "base-company-dialog-w248",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_4 = { class: "base-company-dialog-title" }
const _hoisted_5 = {
  class: "base-company-dialog-w248",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "base-company-dialog-title" }, "开户行信息", -1))
const _hoisted_7 = {
  class: "base-company-dialog-w248",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  style: {"display":"flex","align-items":"center","justify-content":"center","height":"496px"}
}

import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import {
  BaseDialog,
  BaseForm,
  BaseFormRef,
  BaseFormItem,
  BaseInput,
  BaseSelect,
  BaseTextContent,
  BaseImage,
  BaseButton,
  XrkMessage
} from 'xrk-components';
import _ from 'lodash';

import { entpTypeEnum } from '@/common/constants/company/index';
import appStore from '@/store';
import {
  rnvRedirectUrl,
  entpLoginUser,
  entpBankBuild
} from '@/common/data-source/common/apis';
import { formatter } from '@/utils';

interface FormData {
  entpName: string;
  userName: string;
  entpCertType: 1 | 2;
  entpCertNo: string;
  entpCertPic: string;
  realName: string;
  cardId: string;
  deptName: string;
  entpStatusName: string;
  entpUserId: number;
  createAt: string;
  authStatus: number;
  contactorPhone: string;
  legalName: string;
  phone: string;
  isSkip: 0 | 1;
  bankCardNumber: string; // 银行账号
  bankName: string; // 开户行
  accountName: string; // 账户名称
  deptId: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'base-company-dialog',
  props: {
    remove: {}
  },
  setup(__props: any) {

const props = __props;

const CERTIFICATE_TYPE = {
  1: { label: '统一社会信用代码', value: 1 },
  2: { label: '工商注册号', value: 2 }
};

const { info, defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);
const isAsp = computed(() => defaultUserFnCode.value === entpTypeEnum.FWS);

const baseFormRef = ref<BaseFormRef>(null);
const formData = ref<FormData>({
  entpName: '',
  userName: null,
  entpCertType: null,
  entpCertNo: '',
  entpCertPic: '',
  realName: '',
  cardId: null,
  deptName: '',
  entpStatusName: null,
  entpUserId: null,
  createAt: '',
  authStatus: null,
  contactorPhone: null,
  legalName: '',
  phone: '',
  isSkip: null,
  bankCardNumber: null,
  bankName: null,
  accountName: null,
  deptId: null
});

const baseData = ref(null);
const getData = async () => {
  try {
    const res = await entpLoginUser();
    formData.value = {
      ...res.data,
      entpStatusName: !info.value.isSkip ? '已完成实名认证' : '未完成实名认证',
      isSkip: info.value.isSkip,
      createAt: formatter.date(new Date(res.data.createAt))
    };
    baseData.value = _.cloneDeep(formData.value);

    formData.value.entpCertNo = formatter.maskAllMethod({
      type: 'bankCard',
      val: formData.value.entpCertNo
    });
    formData.value.cardId = formatter.maskAllMethod({
      type: 'idCard',
      val: formData.value.cardId
    });
    formData.value.realName = formatter.maskAllMethod({
      type: 'name',
      val: formData.value.realName
    });

    formData.value.phone = formatter.maskAllMethod({
      type: 'phone',
      val: formData.value.phone
    });
    formData.value.contactorPhone = formatter.maskAllMethod({
      type: 'phone',
      val: formData.value.contactorPhone
    });
    formData.value.legalName = formatter.maskAllMethod({
      type: 'name',
      val: formData.value.legalName
    });
  } catch (error) {
    console.log(error);
  }
};
getData();

const onCancel = () => props.remove();

const isIframe = ref(false);
const redirectUrl = ref('');
const iframeLoad = () => {
  window.addEventListener('message', async e => {
    if (!['enterprise-real-dialog'].includes(e.data)) return;

    redirectUrl.value = '';
    await getData();
    isIframe.value = false;
  });
};

const loading = ref(false);
const onResetReal = async () => {
  loading.value = true;
  try {
    const res = await rnvRedirectUrl({
      entpName: baseData.value.entpName, // 企业名称
      entpCertPic: baseData.value.entpCertPic, // 营业执照URL
      entpCertType: baseData.value.entpCertType, // 企业证件编码类型1统一社会信用码2工商注册号
      entpCertNo: baseData.value.entpCertNo, // 企业证件号
      legalName: baseData.value.legalName, // 企业法人姓名
      contactor: baseData.value.realName, // 联系人姓名
      contactorPhone: baseData.value.contactorPhone, // 联系人手机号
      contactId: baseData.value.cardId, // 联系人身份证号
      redirectUrl:
        window.location.origin +
        '/#/main/enterprise-real/enterprise-real-redirect?type=dialog', // E签宝实名完成前端跳转页面
      deptId: info.value.deptId, // 部门id
      isSkip: baseData.value.isSkip,
      entityType: info.value.entpType
    });
    loading.value = false;
    redirectUrl.value = res?.data?.authShortUrl || res?.data?.authUrl;
    if (!redirectUrl.value) {
      XrkMessage.error('地址获取失败');
      return;
    }

    isIframe.value = true;
  } catch (error) {
    loading.value = false;
  }
};

const validate = async () => {
  try {
    await baseFormRef.value.validate();
  } catch (error) {
    const timer = setTimeout(() => {
      clearTimeout(timer);
      const el = document.querySelectorAll('.xrk-form-item__error');
      el?.[0]?.scrollIntoView({
        block: 'center',
        inline: 'center',
        behavior: 'smooth'
      });
    }, 200);
    return Promise.reject();
  }
};
const onSave = async () => {
  try {
    await validate();
    await entpBankBuild({
      bankCardNumber: formData.value.bankCardNumber,
      bankName: formData.value.bankName,
      accountName: formData.value.accountName,
      deptId: formData.value.deptId
    });
    XrkMessage.success('操作成功');
    props.remove();
  } catch (error) {
    console.log(error);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    title: !isIframe.value ? '账号信息' : '企业实名认证',
    width: !isIframe.value ? '800px' : '1200px',
    "model-value": true,
    "custom-class": "base-company-dialog"
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("返回")
        ]),
        _: 1
      }),
      (isAsp.value)
        ? (_openBlock(), _createBlock(_unref(BaseButton), {
            key: 0,
            click: onSave
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          (!isIframe.value)
            ? (_openBlock(), _createBlock(_unref(BaseForm), {
                key: 0,
                ref_key: "baseFormRef",
                ref: baseFormRef,
                "label-position": "top",
                model: formData.value,
                "column-count": 2
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("span", null, "企业信息（" + _toDisplayString(formData.value.entpStatusName) + "）", 1),
                    (formData.value.isSkip)
                      ? (_openBlock(), _createBlock(_unref(BaseButton), {
                          key: 0,
                          style: {"margin-left":"6px","height":"30px"},
                          size: "small",
                          loading: loading.value,
                          onClick: onResetReal
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 前往实名认证 ")
                          ]),
                          _: 1
                        }, 8, ["loading"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_unref(BaseFormItem), {
                      label: "企业名称",
                      prop: "entpName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(BaseInput), {
                          class: "base-company-dialog-w248",
                          type: "text",
                          placeholder: "请输入企业名称",
                          disabled: "",
                          inputTextReplace: "",
                          "show-word-limit": "",
                          maxlength: 50,
                          modelValue: formData.value.entpName,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.entpName) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(BaseFormItem), {
                      label: "企业证件类型",
                      prop: "entpCertNo"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(BaseSelect), {
                          class: "base-company-dialog-w248",
                          placeholder: "请选择企业证件类型",
                          disabled: "",
                          options: Object.values(CERTIFICATE_TYPE),
                          modelValue: formData.value.entpCertType,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.entpCertType) = $event))
                        }, null, 8, ["options", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_unref(BaseFormItem), {
                    label: "营业执照",
                    prop: "entpCertPic"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(BaseImage), {
                        style: {"width":"120px","height":"120px"},
                        fit: "contain",
                        "zoom-rate": 1.2,
                        "max-scale": 7,
                        "min-scale": 0.2,
                        "initial-index": 4,
                        src: formData.value.entpCertPic,
                        "preview-src-list": [formData.value.entpCertPic]
                      }, null, 8, ["src", "preview-src-list"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(BaseFormItem), {
                    label: "企业证件编号",
                    prop: "entpCertNo"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(BaseInput), {
                        class: "base-company-dialog-w248",
                        type: "text",
                        placeholder: "请输入企业证件编号",
                        disabled: "",
                        "show-word-limit": "",
                        inputTextReplace: "",
                        inputTexts: ['英文字母', '数字'],
                        maxlength: 18,
                        modelValue: formData.value.entpCertNo,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.entpCertNo) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(BaseFormItem), {
                    label: "法人代表姓名",
                    prop: "entpCertNo"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(BaseInput), {
                        class: "base-company-dialog-w248",
                        type: "text",
                        placeholder: "请输入法人代表姓名",
                        disabled: "",
                        "show-word-limit": "",
                        inputTextReplace: "",
                        modelValue: formData.value.legalName,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.legalName) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _hoisted_2,
                  _createVNode(_unref(BaseFormItem), {
                    label: "用户名",
                    prop: "userName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(BaseInput), {
                        class: "base-company-dialog-w248",
                        placeholder: "请输入用户名",
                        disabled: "",
                        "show-word-limit": "",
                        maxlength: 11,
                        modelValue: formData.value.userName,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.userName) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(BaseFormItem), {
                    label: "手机号",
                    prop: "phone"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_unref(BaseInput), {
                          style: {"flex":"1"},
                          placeholder: "请输入手机号",
                          disabled: "",
                          "show-word-limit": "",
                          maxlength: 11,
                          modelValue: formData.value.phone,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.phone) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_4, " 企业经办人信息（" + _toDisplayString(formData.value.entpStatusName) + "） ", 1),
                  _createVNode(_unref(BaseFormItem), {
                    label: "姓名",
                    prop: "realName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(BaseInput), {
                        class: "base-company-dialog-w248",
                        type: "text",
                        placeholder: "请输入姓名",
                        disabled: "",
                        "show-word-limit": "",
                        maxlength: 18,
                        modelValue: formData.value.realName,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.realName) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(BaseFormItem), {
                    label: "身份证号",
                    prop: "cardId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(BaseInput), {
                        class: "base-company-dialog-w248",
                        placeholder: "请输入身份证号",
                        disabled: "",
                        "show-word-limit": "",
                        inputTextReplace: "",
                        inputTexts: ['英文字母', '数字'],
                        maxlength: 18,
                        modelValue: formData.value.cardId,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.cardId) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(BaseFormItem), {
                    label: "手机号",
                    prop: "contactorPhone"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_unref(BaseInput), {
                          style: {"flex":"1"},
                          placeholder: "请输入手机号",
                          disabled: "",
                          "show-word-limit": "",
                          inputTextReplace: "",
                          inputTexts: ['数字'],
                          maxlength: 11,
                          modelValue: formData.value.contactorPhone,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.contactorPhone) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  (isAsp.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_6,
                        _createVNode(_unref(BaseFormItem), {
                          label: "账户名称",
                          prop: "accountName",
                          rules: [
              {
                required: true,
                message: '请输入账户名称',
                trigger: 'change'
              }
            ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(BaseInput), {
                              class: "base-company-dialog-w248",
                              type: "text",
                              placeholder: "请输入账户名称",
                              modelValue: formData.value.accountName,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.accountName) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(BaseFormItem), {
                          label: "开户行",
                          prop: "bankName",
                          rules: [
              {
                required: true,
                message: '请输入开户行',
                trigger: 'change'
              }
            ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(BaseInput), {
                              class: "base-company-dialog-w248",
                              placeholder: "请输入开户行",
                              modelValue: formData.value.bankName,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.bankName) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(BaseFormItem), {
                          label: "银行账号",
                          prop: "bankCardNumber",
                          rules: [
              {
                required: true,
                message: '请输入银行账号',
                trigger: 'change'
              }
            ]
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_unref(BaseInput), {
                                style: {"flex":"1"},
                                placeholder: "请输入银行账号",
                                modelValue: formData.value.bankCardNumber,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.bankCardNumber) = $event))
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _: 1
                        })
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["model"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (redirectUrl.value)
                  ? (_openBlock(), _createElementBlock("iframe", {
                      key: 0,
                      ref: "iframeRef",
                      src: redirectUrl.value,
                      frameborder: "0",
                      width: "960px",
                      height: "700px",
                      onLoad: iframeLoad
                    }, null, 40, _hoisted_8))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, " 加载中 ... "))
              ], 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "width"]))
}
}

})